import { render, staticRenderFns } from "./PsPatientBtnNewWeekend.vue?vue&type=template&id=06e17f28&scoped=true&"
import script from "./PsPatientBtnNewWeekend.vue?vue&type=script&lang=js&"
export * from "./PsPatientBtnNewWeekend.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientBtnNewWeekend.vue?vue&type=style&index=0&id=06e17f28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e17f28",
  null
  
)

export default component.exports